/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { NumericFormat } from 'react-number-format';
import Style from '../css/NumericCell.module.css';
import { TableCell } from '@mui/material';

type NumericCellType = {
  value: string;
};

/**
 * Number formatted non-editable cell for re-use.
 */
export default function NumericCell(props: NumericCellType) {
  return (
    <TableCell align='center' className={Style.cell}>
      <NumericFormat
        value={props.value}
        prefix={'$'}
        decimalScale={2}
        fixedDecimalScale
        thousandsGroupStyle='thousand'
        displayType='text'
        thousandSeparator=','
      />
    </TableCell>
  );
}
